import DwemerBootsFooterLangListener from './DwemerBootsFooterLangListener'
import LanguagePath from './LanguagePath'

enum Language {
  English = 'en',
  French = 'fr',
  Italian = 'it',
  German = 'de',
  Spanish = 'es',
  Polish = 'pl',
  Russian = 'ru',
  Portuguese = 'pt',
  Japanese = 'ja',
  Korean = 'ko',
  Turkish = 'tr',

  // note: for locale codes, must capitalize locality to match Bethesda.net site
  ChineseSimplified = 'zh-CN',
  ChineseTraditional = 'zh-TW',
}

// Single source of truth for display names keyed by Language
export const LanguageDisplayNames: Record<Language, string> = {
  [Language.English]: 'English',
  [Language.French]: 'Français',
  [Language.Italian]: 'Italiano',
  [Language.German]: 'Deutsch',
  [Language.Spanish]: 'Español',
  [Language.Polish]: 'Polski',
  [Language.Russian]: 'Русский',
  [Language.Portuguese]: 'Português',
  [Language.Japanese]: '日本語',
  [Language.Korean]: '한국어',
  [Language.Turkish]: 'Türkçe',
  [Language.ChineseSimplified]: '简体中文',
  [Language.ChineseTraditional]: '繁體中文',
}

/**
 * Return the enum value from the string value.
 * Supports only the languages in the enum and defaults to Language.English.
 *
 * @param {string} str language code to convert
 * @returns {{ lang: Language, valid: boolean }}
 */
export const stringToLanguage = (str: string | undefined): { lang: Language; valid: boolean } => {
  if (!str) return { lang: Language.English, valid: false }

  const languageValues = Object.values(Language) as string[]
  const found = languageValues.find((code) => code.toLowerCase() === str.toLowerCase())

  if (found) {
    return { lang: found as Language, valid: true }
  }

  return { lang: Language.English, valid: false }
}

/**
 * Get all available languages as options for dropdown
 * @returns {Array<{value: Language, label: string}>} array of language options
 */
export const getLanguageOptions = (): Array<{ value: Language; label: string }> => {
  return Object.values(Language).map((code) => ({
    value: code,
    label: LanguageDisplayNames[code],
  }))
}

export { DwemerBootsFooterLangListener, Language, LanguagePath }
